import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import moment from "moment";
import { Link } from "react-router-dom";
import { mConstants } from "../../../../helper/constants";
import { IoPagination } from "../../../../helper/pagination";
import { Action, ActionType } from "../../customer/entity/customer.model";
import { COption, CustomerRequest } from "../entity/customer-request.model";
import CustomImage from "../../../../component/CustomImage";

export interface CustomerRequestTableProps {
  pagination: IoPagination<CustomerRequest>;
  onChange: (page: number, pageSize: number) => void;
}

function CustomerRequestTable(props: CustomerRequestTableProps) {
  const customerRequestTableColumns: ColumnsType<CustomerRequest> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Харилцагчийн нэр",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Регистрийн дугаар",
      dataIndex: "registryNumber",
      key: "registryNumber",
    },
    {
      title: "Үүсгэсэн ажилтан",
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: "Хүсэлтийн төрөл",
      dataIndex: "customerRequestType",
      key: "customerRequestType",
      render: (value) => {
        switch (value) {
          case "ADD":
            return "Шинээр нэмэгдсэн";
          case "UPDATE":
            return "Өөрчлөлт оруулсан";
          default:
            return "Тодорхойгүй";
        }
      },
    },
    {
      title: "Үүсгэсэн огноо",
      dataIndex: "createdDate",
      key: "createdDate",
      render(value: Date) {
        return moment(value).format(mConstants.DATETIME_FORMAT);
      },
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      render(value: string) {
        switch (value) {
          case "APPROVED":
            return "Зөвшөөрсөн";

          case "CANCELLED":
            return "Цуцласан";

          case "NEW":
            return "Шинэ";

          default:
            break;
        }
      },
    },
    {
      title: "Дэлгүүрийн зураг",
      dataIndex: "storeImagePaths",
      key: "storeImagePaths",
      render: (storeImagePaths: any) => (
        <div className="d-flex flex-wrap" style={{ width: "70" }}>
          {storeImagePaths &&
            storeImagePaths?.map((route: any) => (
              <div className="mr-1 mb-1 " key={route}>
                <CustomImage
                  alt={
                    mConstants.API_URL +
                    mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                    route
                  }
                  src={
                    mConstants.API_URL +
                    mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                    route
                  }
                  size="sm"
                />
              </div>
            ))}
        </div>
      ),
    },
    {
      title: "Бичиг баримтын зураг",
      dataIndex: "documentImagePaths",
      key: "documentImagePaths",
      render: (documentImagePaths: any) => (
        <div className="d-flex flex-wrap" style={{ width: "70" }}>
          {documentImagePaths &&
            documentImagePaths?.map((route: any) => (
              <div className="mr-1 mb-1" key={route}>
                <CustomImage
                  alt={
                    mConstants.API_URL +
                    mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                    route
                  }
                  src={
                    mConstants.API_URL +
                    mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                    route
                  }
                  size="sm"
                />
              </div>
            ))}
        </div>
      ),
    },
    {
      title: "Үйлдлүүд",
      align: "center",
      key: "actions",
      dataIndex: "actions",
      render: (actions: Action[], record: CustomerRequest) => (
        <div className="list-icons">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right">
              {actions.map((action: Action) => {
                if (action.type === ActionType.edit) {
                  return (
                    <Link
                      to={`/customer/requests/${record.uuid}`}
                      className="dropdown-item"
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </Link>
                  );
                }
              })}
            </div>
          </div>
        </div>
      ),
    },
  ];

  const customerRequests: CustomerRequest[] = props.pagination.content.map(
    (customerRequest, index) => {
      const actions: Action[] = [
        { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
      ];
      return {
        ...customerRequest,
        actions: actions,
        index: index + 1,
        key: index,
      };
    }
  );

  return (
    <Table
      className="table table-responsive"
      columns={customerRequestTableColumns}
      dataSource={customerRequests}
      pagination={{
        defaultCurrent: props.pagination.current,
        total: props.pagination.totalElements,
        onChange: props.onChange,
      }}
    />
  );
}

export default CustomerRequestTable;
